import { render, staticRenderFns } from "./GFooter.vue?vue&type=template&id=473d0722&scoped=true"
import script from "./GFooter.vue?vue&type=script&lang=js"
export * from "./GFooter.vue?vue&type=script&lang=js"
import style0 from "./GFooter.vue?vue&type=style&index=0&id=473d0722&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "473d0722",
  null
  
)

export default component.exports